// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"19a25077","453":"03346f77","754":"871f5ef7"}[chunkId] + ".chunk.js";
};